/* eslint-disable import/no-cycle */
import { GroupDelegate } from '@leverege/molten-core';
import { GlobalState } from '@leverege/ui-redux';
import Util from "../screens/Util.js";
import RsrcFilterModel from "../filter/RsrcFilterModel.js";
import RsrcSortModel from "../filter/RsrcSortModel.js";
import ImagineRsrcItemDelegate from "./ImagineRsrcItemDelegate.js";
export default class ImagineRsrcGroupDelegate extends GroupDelegate {
  static TYPE = 'imagineRsrc.GroupDelegate';
  static getQueryOptions(state = GlobalState.get()) {
    const {
      router: {
        location
      }
    } = state;
    return Util.decodeQuery(location);
  }
  constructor(opts) {
    super(opts);
    this.type = ImagineRsrcGroupDelegate.TYPE;
    this.resourceApi = this.parent().createObj();
  }
  getSubRsrcs(item, state = GlobalState.get()) {
    if (!item.data?.metadata?.subrsrc) {
      return null;
    }
    const rsrcs = {};
    Object.entries(item.data.metadata.subrsrc).forEach(([key, value]) => {
      rsrcs[key] = {
        path: value,
        rsrc: this.item(value).getItem(state)
      };
    });
    return rsrcs;
  }
  search(obj, options) {
    const {
      filter,
      sort,
      queryName,
      ...rest
    } = obj;
    const {
      path,
      ...f
    } = filter || {};
    return this.resourceApi.rsrc(path || null).list({
      order: sort || [['createdAt', 'DESC']],
      filter: f && Object.keys(f).length > 0 ? f : RsrcFilterModel.toRsrcFilter(),
      ...rest
    }, {
      ...options,
      queryName: queryName || this.queryName
    });
  }
  isGotoAllowed() {
    return false;
  }
  convertToFilter(value, cxt) {
    return value ? RsrcFilterModel.toRsrcFilter(value) : null;
  }
  convertToSort(value, cxt) {
    return value ? RsrcSortModel.toRsrcOrder(value) : null;
  }
  isAttributeFiltered = (attribute, filter) => {
    return false;
  };
  isAttributeSorted = (attribute, sort) => {
    if (!sort || !attribute) {
      return false;
    }
    return sort.sorts.some(sort => sort.field === attribute.sourceOptions?.sortField);
  };
  getList(state = GlobalState.get(), opts = {}) {
    const q = ImagineRsrcGroupDelegate.getQueryOptions(state);
    const path = q?.filters?.filter?.path;
    return this.resourceApi.rsrc(path).listRsrcs(state, {
      ...opts,
      queryName: this.queryName
    });
  }
  item(path) {
    const iRel = this.relationship.createItem(this.relationship.match, path);
    return new ImagineRsrcItemDelegate({
      match: iRel.match,
      relationship: iRel,
      path,
      resourceApi: this.resourceApi,
      queryName: this.queryName
    });
  }
  isLoading(state = GlobalState.get()) {
    const q = ImagineRsrcGroupDelegate.getQueryOptions(state);
    const path = q?.filters?.filter?.path;
    return this.resourceApi.rsrc(path).getStatus(state, {
      queryName: this.queryName
    })?.status === 'loading';
  }
  toObjectRef(item) {
    return {
      id: item.id,
      ref: this.relationship.ref,
      type: this.relationship.objectType,
      data: item
    };
  }
  canCreate() {
    return false;
  }
  canDelete() {
    return true;
  }
  canUpdate() {
    return true;
  }
}